import { Grid, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button, Input, InputRadio } from "../../../controls";
import { DropLi, Model, UseForm } from "../../../hooks";
import { Form } from "../../../layout";
import { action, API, controller } from "../../../api/api";
import { RmvEmptyProp, ToFormData } from "../../../hooks/Method";

const CashAddAndRemove = (props) => {
  const {
    setAlert,
    setShowForm,
    isCashInForm = true,
    setTxns,
    activeReg,
    authUser,
  } = props;
  const { TxnTypes } = DropLi();
  const { CashMgmtMdl } = Model();
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
  } = UseForm(CashMgmtMdl);

  useEffect(() => {
    if (isCashInForm) {
      setTypes([...TxnTypes.filter((j) => j.id === 1 || j.id === 3)]);
      setValues((j) => ({ ...j, txnType: 1 }));
    } else {
      setTypes([...TxnTypes.filter((j) => j.id === 2 || j.id === 4)]);
      setValues((j) => ({ ...j, txnType: 2 }));
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCashInForm]);

  const validateForm = () => {
    let temp = {};
    temp.amount = values.amount !== "" ? "" : "Amount is required.";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(false);
      const onComplete = (res) => {
        if (res && res.status === 201) {
          setTxns((x) => [res.result, ...x]);
          resetFormControls();
          setAlert({
            isOpen: true,
            type: "success",
            title: "Success",
            subTitle: `Cash ${isCashInForm ? "added" : "removed"} successfully`,
          });
        } else if (res)
          setAlert({
            isOpen: true,
            type: "error",
            title: "Error",
            subTitle: res.msg,
          });
        setShowForm(false);
      };
      if (activeReg && activeReg.id) {
        if (!isCashInForm) values.amount = -values.amount;
        API(controller.CashMgmt + action.Post).post(
          ToFormData(
            RmvEmptyProp({
              ...values,
              orgId: authUser.orgId,
              userId: authUser.id,
              sellRegId: activeReg.id,
              txnDate: new Date().toISOString(),
            })
          ),
          onComplete
        );
      }
    }
  };

  const handleClose = () => {
    setShowForm(false);
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper>
          <Grid container spacing={3} className="p-[15px]">
            <Grid
              item
              xs={12}
              className="text-center p-[20px] !pt-[40px] w-[100%]"
            >
              <span className="font-medium text-[24px] text-gray-500">
                {isCashInForm ? "Add" : "Remove"} Cash
              </span>
              <div className=" flex justify-center">
                <div className="border-bottom w-[60px]" />
              </div>
            </Grid>
            <Grid item xs={12}>
              <InputRadio
                label="Transaction Type"
                name="txnType"
                value={values.txnType}
                onChange={handleInpChg}
                options={types}
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                label="Amount"
                name="amount"
                type="number"
                placeholder="0.00"
                value={values.amount}
                error={errors.amount}
                required={true}
                onChange={handleInpChg}
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                label="Note"
                name="note"
                value={values.note}
                error={errors.note}
                multiline
                rows={2}
                onChange={handleInpChg}
                inputProps={{ maxLength: 100 }}
              />
            </Grid>
            <Grid item xs={12}>
              <div className="flex gap-[10px]">
                <Button
                  fullWidth
                  size="large"
                  variant="text"
                  onClick={handleClose}
                >
                  Cancel
                </Button>

                {isCashInForm ? (
                  <Button
                    fullWidth
                    size="large"
                    loading={loading}
                    type="submit"
                  >
                    Add Cash
                  </Button>
                ) : (
                  <Button
                    fullWidth
                    size="large"
                    loading={loading}
                    type="submit"
                    color="error"
                  >
                    Remove Cash
                  </Button>
                )}
              </div>
            </Grid>
          </Grid>
        </Paper>
      </Form>
    </>
  );
};

export default CashAddAndRemove;
